import React from 'react';
import css from './BlogListing.module.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { H4 } from '../Heading/Heading';
import NamedLink from '../NamedLink/NamedLink';

const blogItems = [
  {
    id: 1,
    image: '/assets/stroller.png',
    tag: 'Top 5 Uses',
    title: 'Pro Tips for Getting the Most Out of Your Travel Stroller',
    desc:
      'Learn what seasoned renters do to pack smarter, fold faster, and keep their little one happy on the go.',
  },
  {
    id: 2,
    image: '/assets/camera.png',
    tag: 'How To',
    title: 'How to Choose the Right Camera for Your Trip',
    desc:
      'Discover the best camera features for travel and how to capture memories like a pro.',
  },
  {
    id: 3,
    image: '/assets/tent.png',
    tag: 'Guide',
    title: 'Camping Gear Essentials for Beginners',
    desc:
      'A quick guide to must-have camping gear for a safe and comfortable outdoor adventure.',
  },
];

const MAX_TITLE_LEN = 60;
const MAX_DESC_LEN = 100;

function truncate(str, n) {
  if (!str) return '';
  return str.length > n ? str.slice(0, n - 1) + '…' : str;
}

const BlogListing = ({ blogs, fetchBlogsInProgress, fetchBlogsError }) => {
  if (fetchBlogsInProgress) {
    return <div className={css.loading}>Loading blog highlights…</div>;
  }
  // Because old listings don't have blogs, we return null if blogs is empty
  // if (fetchBlogsError) {
  //   return <div className={css.error}>Could not load blog highlights.</div>;
  // }
  if (!blogs || blogs.length === 0) return null;

  return (
    <>
      <H4 className={css.itemTitle}>Blog Highlights for This Listing</H4>
      <p className={css.itemSubTitle}>
        Relevant posts created by the owner to help you decide, use, and
        care for this item.
      </p>
      <div className={css.blogItems}>
        <Swiper
          spaceBetween={24}
          slidesPerView={3}
          navigation
          style={{ padding: '8px 0' }}
          breakpoints={{
            320: { slidesPerView: 1 },
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {blogs.map(blog => {
            const title = truncate(blog.title, MAX_TITLE_LEN);
            const imageUrl = blog.image?.imageUrl || blog.image?.secure_url;
            const tag = blog.label || '';
            // Prefer content.excerpt, fallback to description or empty
            const desc = truncate(blog.content?.excerpt || blog.content?.description || '', MAX_DESC_LEN);
            return (
              <SwiperSlide key={blog._id || blog.id}>
                <NamedLink
                  name="BlogContentPage"
                  params={{ blogId: blog._id || blog.id, listingId: blog.listingId }}
                >
                  <div className={css.blogCard}>
                    {imageUrl && <img className={css.blogCardImg} src={imageUrl} alt={title} />}
                    <div className={css.blogCardContent}>
                      {tag && <div className={css.blogCardTag}>{tag}</div>}
                      <div className={css.blogCardTitle}>{title}</div>
                      <div className={css.blogCardDesc}>{desc}</div>
                    </div>
                  </div>
                </NamedLink>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </>
  );
};

export default BlogListing;
